module.exports = __webpack_public_path__ + "static/media/cc.17235b13.svg";